define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ServiceResponse = (function () {
        function ServiceResponse() {
            this.success = false;
            this.obj = null;
            this.message = null;
        }
        ServiceResponse.Success = function (obj, message, log) {
            if (obj === void 0) { obj = null; }
            if (log === void 0) { log = false; }
            return this.Create(true, obj, message, log);
        };
        ServiceResponse.Error = function (obj, message, log) {
            if (obj === void 0) { obj = null; }
            if (log === void 0) { log = true; }
            return this.Create(false, obj, message, log);
        };
        ServiceResponse.Create = function (success, obj, message, log) {
            if (obj === void 0) { obj = null; }
            if (obj == undefined)
                obj = null;
            var res = new ServiceResponse();
            res.success = success;
            res.obj = obj;
            res.message = message;
            if (log) {
                var log_1 = success ? console.info : console.error;
                log_1(res);
            }
            return res;
        };
        return ServiceResponse;
    }());
    exports.default = ServiceResponse;
});
